<template>
    <div
        v-if="popup"
        class="air-container air-container-vmeste-pop"
        :class="showAir ? 'air-container_active' : ''"
    >
        <div class="popup-air" :class="showAir ? 'popup-air_active' : ''">
            <div class="air-close" @click="close()"></div>
            <div class="vmeste-popup">
                <picture class="vmeste-popup__hero">
                    <source media="(max-width: 560px)" :srcset="popup.image_mobile">
                    <img :src="popup.image_desktop" alt="">
                </picture>
                <button type="button" class="btn btnV2 vmeste-popup__btn" @click="onBtnClick()">
                    {{ popup.button_text }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../store.js';

const DAY_MS = 86400 * 1000

export default {
    name: 'VmestePopup',
    data() {
        return {
            showAir: false,
            openTimer: null,
        }
    },
    computed: {
        popup() {
            const popup = this.$store.state.settings?.promo_popup
            if (!popup?.active || !popup.storage_key || !popup.image_desktop || !popup.image_mobile) {
                return null
            }
            return popup
        },
    },
    mounted() {
        if (!this.popup) {
            return
        }

        const stored = this.readPromoStorage()
        if (stored && (Date.now() - stored.time) < DAY_MS) {
            if (stored.shown) {
                store.commit('setPromoPopupShown')
            }
            store.commit('setVmestePopupDone')
            return
        }

        this.openTimer = setTimeout(() => {
            this.showAir = true
            store.commit('setPromoPopupShown')
        }, 3000)
    },
    beforeUnmount() {
        if (this.openTimer) {
            clearTimeout(this.openTimer)
        }
    },
    methods: {
        readPromoStorage() {
            try {
                return JSON.parse(localStorage.getItem(this.popup.storage_key))
            } catch (e) {
                return null
            }
        },
        writePromoStorage(payload) {
            localStorage.setItem(this.popup.storage_key, JSON.stringify(payload))
            sessionStorage.removeItem(this.popup.storage_key)
        },
        close() {
            this.showAir = false
            if (this.popup) {
                this.writePromoStorage({ time: Date.now(), shown: true })
            }
            store.commit('setVmestePopupDone')
            if (this.openTimer) {
                clearTimeout(this.openTimer)
                this.openTimer = null
            }
        },
        onBtnClick() {
            const url = this.popup?.button_url
            this.close()
            if (url) {
                window.location.href = url
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.air-container-vmeste-pop {
  .popup-air {
    padding: 0;
    width: 520px;
    min-width: 520px;
    max-width: 520px;
    flex-shrink: 0;
    border: none;
    overflow: hidden;
    background: transparent;

    .air-close {
      top: 12px;
      right: 12px;
      z-index: 10;
    }
  }
}

.vmeste-popup {
  position: relative;
  width: 100%;

  &__hero {
    display: block;
    width: 100%;
    line-height: 0;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__btn {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 200px;
    background: #000;
    color: #fff;
    border: none;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 1;
    padding: 14px 24px;
    cursor: pointer;
    z-index: 2;

    &:hover {
      background: #333;
    }
  }
}

@media screen and (max-width: 560px) {
  .air-container-vmeste-pop {
    .popup-air {
      width: calc(100vw - 40px);
      min-width: calc(100vw - 40px);
      max-width: calc(100vw - 40px);
      margin: 0 20px;
    }
  }

  .vmeste-popup__btn {
    bottom: 5%;
    transform: translate(-50%, -50%);
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

@media screen and (max-width: 399px) {
  .vmeste-popup__btn {
    width: calc(100% - 40px);
    max-width: none;
  }
}
</style>
